// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--AIN-Y","blue":"card-module--blue--ICAHe","gray":"card-module--gray--3tH2g","orange":"card-module--orange--24P7t"};